<!-- TODO remove or revise colons ":" 'cause of translations -->
<div
    class="cmps-cdk-min-w-100px cmps-cdk-min-h-40p cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-px-0dot5 cmps-cdk-py-0dot25 cmps-cdk-bg-color-white cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-radius-5px {{
        data.winningBorderColour
    }}"
    [class.cmps-wp-percentage--bg-red-fifty]="data.winningPercentage === 0"
    [cmpsTooltipTrigger]="percentageTooltip"
    [trigger]="data.tooltipEnabled === true ? null : 'none'"
    [cmpsTooltipTriggerCustomTemplate]="true"
>
    <div class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-w-100pct">
        <div
            class="justify-content-between cmps-cdk-d-flex cmps-cdk-align-items-center cmps-wp-percentage--height cmps-cdk-px-0dot25"
        >
            <div
                class="cmps-cdk-min-w-12px cmps-cdk-min-h-12p cmps-cdk-border-radius-4px cmps-cdk-mr-0dot25"
                [style.background]="
                    data.winningThresholdColour | cmpsBgGradient
                "
            ></div>
            <!-- ToDo: text font should be semi-bold (not in CDK yet) -->
            <span class="cmps-cdk-font-size-18p cmps-cdk-font-bold">
                {{
                    data.winningPercentage == null
                        ? '-'
                        : (data.winningPercentage | cmpsWpPercent)
                }}
            </span>
        </div>
        <div
            class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-flex-end cmps-cdk-pt-0dot25 cmps-cdk-color-black cmps-wp-percentage--height {{
                data.winningChangeColour
            }}"
        >
            <cmps-icon
                class="cmps-cdk-d-flex cmps-cdk-px-0dot25 cmps-cdk-mt-0dot25"
                [svgIcon]="data.winningChangeIcon"
            ></cmps-icon>
            <span
                class="cmps-wp-percentage--height cmps-cdk-text-right cmps-cdk-pr-0dot25"
            >
                {{ data.winningChange ?? 0 | cmpsWpPercent }}
            </span>
        </div>
    </div>
</div>

<ng-template #percentageTooltip>
    <cmps-dialog>
        <cmps-dialog-body
            class="cmps-cdk-m-0dot25 cmps-cdk-align-items-end cmps-wp-percentage--tooltip"
        >
            <div
                class="cmps-cdk-d-flex justify-content-between cmps-cdk-my-0dot5"
            >
                <div class="cmps-cdk-font-bold">
                    <ng-container
                        *ngTemplateOutlet="
                            labelTpl;
                            context: {
                                prefix: _i18n._9589_CURRENT,
                                date: data.evalRange?.endDateDataRange
                            }
                        "
                    ></ng-container>
                </div>
                <div
                    class="cmps-cdk-d-flex cmps-cdk-align-items-center justify-content-between cmps-cdk-min-w-55px"
                >
                    <div
                        class="cmps-cdk-min-w-12px cmps-cdk-min-h-12p cmps-cdk-border-radius-4px"
                        [style.background]="
                            data.winningThresholdColour | cmpsBgGradient
                        "
                    ></div>
                    <div>
                        {{
                            data.winningPercentage == null
                                ? '-'
                                : (data.winningPercentage | cmpsWpPercent)
                        }}
                    </div>
                </div>
            </div>
            <div
                class="cmps-cdk-d-flex justify-content-between cmps-cdk-my-0dot5"
            >
                <div class="cmps-cdk-font-bold">
                    <ng-container
                        *ngTemplateOutlet="
                            labelTpl;
                            context: {
                                prefix: _i18n._9796_PREVIOUS,
                                date: data.prevEvalRange?.endDateDataRange
                            }
                        "
                    ></ng-container>
                </div>
                <div
                    class="cmps-cdk-d-flex cmps-cdk-align-items-center justify-content-between cmps-cdk-min-w-55px"
                >
                    <div
                        class="cmps-cdk-min-w-12px cmps-cdk-min-h-12p cmps-cdk-border-radius-4px"
                        [style.background]="
                            data.prevWinningThresholdColour | cmpsBgGradient
                        "
                    ></div>
                    <div>
                        {{
                            data.prevWinningPercentage == null
                                ? '-'
                                : (data.prevWinningPercentage | cmpsWpPercent)
                        }}
                    </div>
                </div>
            </div>
            <div
                class="cmps-cdk-d-flex justify-content-between cmps-cdk-my-0dot5"
            >
                <div class="cmps-cdk-font-bold">
                    {{ _i18n._11186__CHANGE | translate }}:
                </div>
                <div
                    class="cmps-cdk-d-flex cmps-cdk-align-items-center justify-content-between cmps-cdk-min-w-55px"
                    [class.cmps-cdk-color-green-100]="data.winningChange > 0"
                    [class.cmps-cdk-color-red-100]="data.winningChange < 0"
                >
                    <cmps-icon
                        class="cmps-cdk-d-flex cmps-cdk-px-0dot25"
                        [svgIcon]="
                            data.winningChange > 0
                                ? 'arrow-up'
                                : data.winningChange < 0
                                ? 'arrow-down'
                                : 'arrow-left-right'
                        "
                    ></cmps-icon>
                    <div>
                        {{
                            data.winningChange == null
                                ? (0 | cmpsWpPercent)
                                : (data.winningChange | cmpsWpPercent)
                        }}
                    </div>
                </div>
            </div>
            <ng-container *ngIf="data.comparisons?.length > 0">
                <hr class="cmps-cdk-m-0" />
                <ng-container *ngFor="let c of data.comparisons">
                    <div
                        class="cmps-cdk-d-flex justify-content-between cmps-cdk-my-0dot5"
                    >
                        <div class="cmps-cdk-font-bold">
                            {{ c.evalRange?.label }}:
                        </div>
                        <div
                            class="cmps-cdk-d-flex cmps-cdk-align-items-center justify-content-between cmps-cdk-min-w-55px"
                        >
                            <div
                                class="cmps-cdk-min-w-12px cmps-cdk-min-h-12p cmps-cdk-border-radius-4px"
                                [style.background]="
                                    c.winningThresholdColour | cmpsBgGradient
                                "
                            ></div>
                            <div>
                                {{
                                    c.winningPercentage == null
                                        ? '-'
                                        : (c.winningPercentage | cmpsWpPercent)
                                }}
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </cmps-dialog-body>
    </cmps-dialog>
</ng-template>

<!-- TODO revise -->
<ng-template
    let-prefix="prefix"
    let-date="date"
    #labelTpl
>
    <ng-container
        *ngIf="data.evalRange?.labelFormat?.startsWith('date:') === true"
    >
        {{
            (date | cmpsDate: data.evalRange?.labelFormat?.split(':')[1]) +
                ' ' +
                (_i18n._10094_WINNING_PERCENTAGE | translate)
        }}:
    </ng-container>
    <ng-container
        *ngIf="data.evalRange?.labelFormat?.startsWith('date:') !== true"
    >
        {{
            (prefix | translate) +
                ' ' +
                (_i18n._10094_WINNING_PERCENTAGE | translate)
        }}:
    </ng-container>
</ng-template>
